import { css } from '@emotion/react'
import {
  IPickerListItem,
  Picker,
} from '@livechat/design-system-react-components'
import { useMemo, useState } from 'react'

const pickerCss = css`
  min-width: 200px;
  width: 200px;

  div {
    font-weight: 600;
  }
`

interface Option {
  LABEL: string
  VALUE: string
}

interface Props {
  options: Option[]
  onSortChange: (value: string | number) => void
  value: string | number
}

const SortComponent = ({ onSortChange, options, value }: Props) => {
  const defaultOption = options.find(({ VALUE }) => VALUE === value)
  const defaultSelected = defaultOption
    ? [
        {
          key: defaultOption.VALUE,
          name: defaultOption.LABEL,
        },
      ]
    : null
  const [selected, setSelected] = useState<IPickerListItem[] | null>(
    defaultSelected
  )

  const handleSelect = (value: IPickerListItem[] | null) => {
    setSelected(value)

    if (value) {
      onSortChange(value[0].key)
    }
  }

  const pickerOptions: IPickerListItem[] = useMemo(
    () =>
      options.map(({ LABEL, VALUE }) => ({
        key: VALUE,
        name: LABEL,
      })),
    [options]
  )

  return (
    <Picker
      hideClearButton
      options={pickerOptions}
      onSelect={handleSelect}
      selected={selected}
      searchDisabled
      placement="bottom"
      css={pickerCss}
    />
  )
}

export default SortComponent
